<script>
    import CopyClipBoard from "../utils/CopyClipBoard.svelte"
    import {getOrganizations} from "../firestore";

    let organizations = []

    getOrganizations().subscribe(organization => organizations = [...organizations, organization]);

    function copy(name) {
        const app = new CopyClipBoard({
            target: document.getElementById("clipboard"),
            props: {name}
        });
        app.$destroy()
    }

</script>

<svelte:head><title>Axces2 - Organizations</title></svelte:head>

<div class="container-fluid">
    <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
            <h3 class="text-themecolor">Organizations</h3>
            <ol class="breadcrumb">

                <li class="breadcrumb-item">Admin</li>
                <li class="breadcrumb-item active">Organizations</li>
            </ol>
        </div>
    </div>

    <section>
        <div class="card-group">
            {#if organizations.length > 0}
                <div class="card">
                    <div class="card-body">
                        <div class="month-table">
                            <div class="table-responsive mt-3">
                                <table class="table stylish-table mb-0">
                                    <thead>
                                    <tr>
                                        <th>Organization Name</th>
                                        <th>Identification</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {#each organizations as organization, i(organization.id)}
                                        <tr>
                                            <td>
                                                <div>{organization.name}</div>
                                            </td>
                                            <td>
                                                <div>{organization.id}</div>
                                            </td>
                                            <td class="td-actions text-right">
                                                <button on:click={() => copy(organization.id)} rel="tooltip"
                                                        class="btn btn-round">
                                                    <i class="mdi mdi-animation"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    {/each}
                                    </tbody>
                                </table>
                                <!--                            <input class="card-highlight" bind:value={newProduct}/>-->
                                <!--                            <button on:click={newType} class="btn btn-primary">New</button>-->
                            </div>
                        </div>
                    </div>
                </div>
            {:else}
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            {/if}
        </div>
    </section>
</div>

<div id="clipboard"></div>
